import axios from "axios";

export const http = axios.create({
  baseURL: "/api",
  withCredentials: false,
});